import React from "react";
import { ErrorComponent, LoadingSpinner, PageLayout } from "shared";
import { CourseCard, CourseListingText, emptyCourseText, useCourse, useLearningMaterials } from "..";
import { useNavigate } from "react-router-dom";
import ErrorImg from "assets/images/error-robot.png";
import { getSelectedProgram } from "utils";
import { useAppScope, MwcdLogoComopent } from "master";

export const CourseList = ({ type }) => {
  const navigate = useNavigate();
  const selectedProgram = getSelectedProgram();
  const { selectedProgramName } = useLearningMaterials({ load: false, type });
  const { courseList, name, hasCourseGroup, courseType, displayName } =
    useCourse({ type });
  const { isMWCD, lanSettings } = useAppScope();

  const { data } = courseList;
  const isAssignment = courseType === 2;
  const isTheory = courseType === 0;
  const currentName = isAssignment
    ? `${CourseListingText.Assignment[lanSettings?.lan || "en"]}`
    : isTheory
      ? `${CourseListingText.LearningMaterials[lanSettings?.lan || "en"]}`
      : `${CourseListingText.LearningContent[lanSettings?.lan || "en"]}`;

  if (courseList.isPending || courseList.isLoading) {
    return <LoadingSpinner />;
  }

  const breadcrumb = [
    { label: selectedProgramName, location: "/program" },
    {
      label: displayName ? displayName : currentName,
      location: hasCourseGroup
        ? isAssignment
          ? "/program/assignment/coursegroup"
          : isTheory
            ? "/program/learningmaterials/coursegroup"
            : "/program/practicals/coursegroup"
        : "",
    },
  ];

  const titleEndComponent = [
    <div key="logo-group" className="logo-group">
      {isMWCD && (
        <MwcdLogoComopent customClass="logo-group-mwcd_PD marati_logo_empty_page" />
      )}
    </div>,
  ];

  const hasLearningMaterial = data?.length > 0;

  if (hasCourseGroup) {
    breadcrumb.push({ label: name });
  }

  const goToPreviousPage = () => {
    navigate(-1, { replace: true });
  };

  return (
    <PageLayout
      title={
        hasLearningMaterial
          ? hasCourseGroup
            ? name || currentName
            : displayName || currentName
          : false
      }
      breadcrumb={breadcrumb}
      titleEndComponent={titleEndComponent}
      isPageEmpty={!hasLearningMaterial}
    >
      <div className="row">
        <div className="col-12">
          {hasLearningMaterial ? (
            <div className="page-grid-items page-grid-items--row">
              {data?.map((element, index) => {
                return (
                  <CourseCard
                    index={index}
                    key={element?.courseId}
                    name={element?.name}
                    totalTasks={element?.totalTasks}
                    progress={element?.overallPercentage}
                    isAssignment={isAssignment}
                    isTheory={isTheory}
                    duration={element?.totalDuration}
                    onClick={() => navigate(`${element?.courseId}`)}
                    displayDuration={selectedProgram?.displayDuration}
                  />
                );
              })}
            </div>
          ) : (
            <ErrorComponent
              title={emptyCourseText.NoCourse[lanSettings?.lan || "en"]}
              message={emptyCourseText.Message[lanSettings?.lan || "en"]}
              image={ErrorImg}
              btnLabel={emptyCourseText.GoBack[lanSettings?.lan || "en"]}
              onClick={goToPreviousPage}
            />
          )}
        </div>
      </div>
    </PageLayout>
  );
};
